import epsClient from 'enrollment-platform/api/eps.client'
import type {
  CompleteUploadRequestDto,
  DocumentResponseDto,
  PresignUploadUrlRequestDto,
  PresignUploadUrlResponseDto,
} from './dto/plan-override-document.dto'

const DEFAULT_RULE_BASE = '/api/v1/plan-benefit-override-rules'

function documentsBase(ruleId: string, ruleBase = DEFAULT_RULE_BASE): string {
  return `${ruleBase}/${ruleId}/documents`
}

export async function presignUploadUrl(
  ruleId: string,
  body: PresignUploadUrlRequestDto,
  ruleBase?: string
): Promise<PresignUploadUrlResponseDto> {
  const { data } = await epsClient.post<PresignUploadUrlResponseDto>(
    `${documentsBase(ruleId, ruleBase)}/presigned-upload-url`,
    body
  )
  return data
}

export async function completeUpload(
  ruleId: string,
  documentId: string,
  body: CompleteUploadRequestDto,
  ruleBase?: string
): Promise<void> {
  await epsClient.post(
    `${documentsBase(ruleId, ruleBase)}/${documentId}/complete`,
    body
  )
}

export async function listDocuments(
  ruleId: string,
  ruleBase?: string
): Promise<DocumentResponseDto[]> {
  const { data } = await epsClient.get<DocumentResponseDto[]>(
    documentsBase(ruleId, ruleBase)
  )
  return data
}

export async function getDocumentDownloadUrl(
  ruleId: string,
  documentId: string,
  ruleBase?: string
): Promise<string> {
  const { data } = await epsClient.get<{ url: string }>(
    `${documentsBase(ruleId, ruleBase)}/${documentId}/download`
  )
  return data.url
}

export async function deleteDocument(
  ruleId: string,
  documentId: string,
  ruleBase?: string
): Promise<void> {
  await epsClient.delete(`${documentsBase(ruleId, ruleBase)}/${documentId}`)
}
